(function() {

    'use strict';

    angular.module('Services').factory('ClientLocationListTableService', ClientLocationListTableService);
    ClientLocationListTableService.$inject = [
        '$location', 
        'ClientService', 
        'TableLiteFactory',
        'toastr',
        'ConfirmationModalFactory'
    ];
    function ClientLocationListTableService(
        $location, 
        ClientService, 
        TableLiteFactory,
        toastr,
        ConfirmationModalFactory
    ){
        return function (companyId) {
            var deleteConfirmation = new ConfirmationModalFactory({},{
                message: 'messages.warning.delete.MESSAGE',
                code: 'messages.warning.delete.CODE',
            });

            let companiesListTableData = {
                tableName: 'ClientLocationListTableService',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Office / Location',
                        onClick: function () {
                            $location.path(`/clients/${companyId}/location`);
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Location',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    } //Use for sorting
                }, {
                    label: 'Description',
                    viewName: 'description',
                    filterName: 'description',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Contact Person',
                    viewName: 'contactPerson',
                    filterName: 'locationProfile.firstName',
                    sortName: 'firstName',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.sortName);
                    }
                }, {
                    label: 'Email',
                    viewName: 'email',
                    filterName: 'email',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Phone',
                    viewName: 'phoneNumbers',
                    filterName: 'phone1',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Action',
                    viewName: 'action'
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(companiesListTableData,
                {
                    serviceCallback: ClientService.Location.getAll,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        'company.id': companyId
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data, pagination) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (location) {
                    location.phoneNumbers = {
                        type: 'multiLine',
                        list: []
                    };

                    location.name = location.name ? location.name : 'N/A';
                    location.description = location.description ? location.description : 'N/A';
                    location.contactPerson = location.locationProfile ? `${location.locationProfile.firstName} ${location.locationProfile.lastName}` : 'N/A';
                    location.email = location.email ? location.email : 'N/A';

                    if (location.phone1)
                        location.phoneNumbers.list.push(location.phone1);
                    if (location.phone2)
                        location.phoneNumbers.list.push(location.phone2);
                    if (!location.phone1 && !location.phone2)
                        location.phoneNumbers = 'N/A';

                    location.status = location.active ? 'Active' : 'Inactive';
                    location.href = `/clients/${location.company.id}/location/${location.id}`;
                    
                    location.action = {
                        type: 'button',
                        buttons: [{
                            text: 'DELETE',
                            class: 'btn btn-danger',
                            action: location =>{
                                deleteConfirmation.getInstance().result.then(function(cond){
                                    if(cond){
                                        ClientService.Location.deleteOffice(location.id, ()=>{
                                            toastr.success('Location successfully deleted', 'Success');
                                            sendRequest();
                                        }, error=>{
                                            toastr.error(error.message, 'ERROR');
                                        });     
                                    }
                                });
                            }
                        }]
                    }
                    companiesListTableData.data.push(location);
                });
            };
            this.tableData = companiesListTableData;
        }
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ClientLocationListTableService.js